import { useCallback } from 'react';
import {
	useFeedbackCollectorActions,
	type FeedbackCollectorProps,
	ENTRYPOINT_ID_JIRA_COMMAND_PALETTE,
} from '@atlassian/jira-feedback-collector';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

export const useCommandPaletteFeedbackCollector = () => {
	const { openFeedbackCollector, resetFeedbackCollectorState } = useFeedbackCollectorActions();
	const { formatMessage } = useIntl();

	const openCommandPaletteFeedbackCollector = useCallback(
		(props?: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				entrypointId: ENTRYPOINT_ID_JIRA_COMMAND_PALETTE,
				feedbackTitle: formatMessage(messages.feedbackTitle),
				...props,
			});
		},
		[formatMessage, openFeedbackCollector],
	);

	return [openCommandPaletteFeedbackCollector, resetFeedbackCollectorState];
};
